'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _pacomo = require('utils/pacomo');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RequirementName = function RequirementName(_ref) {
    var requirementSet = _ref.requirementSet,
        isComplete = _ref.isComplete;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components2.TranslatedRequirementSetTitle, { requirementSet: requirementSet }),
        !isComplete && _react2.default.createElement(
            'div',
            { className: 'due-by' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'formMessages.dueByDate',
                values: {
                    date: _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedDate, {
                            value: requirementSet.complete_by_date,
                            year: 'numeric', month: 'short', day: 'numeric',
                            timeZone: 'UTC' })
                    )
                } })
        )
    );
};

var DueByDate = function DueByDate(_ref2) {
    var requirementSet = _ref2.requirementSet,
        isComplete = _ref2.isComplete;
    return _react2.default.createElement(
        'div',
        null,
        !isComplete && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'formMessages.dueByDate',
                values: {
                    date: _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedDate, {
                            value: requirementSet.complete_by_date,
                            year: 'numeric', month: 'short', day: 'numeric',
                            timeZone: 'UTC' })
                    )
                } })
        ),
        isComplete && _react2.default.createElement(
            'div',
            { className: 'complete' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'updateTag.completed', defaultMessage: 'Completed' })
        )
    );
};

var CompleteTag = function CompleteTag(_ref3) {
    var isComplete = _ref3.isComplete;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { className: isComplete ? 'completed-requirement' : 'incomplete-requirement' })
    );
};

var UpdateTag = function UpdateTag(_ref4) {
    var isComplete = _ref4.isComplete;
    return _react2.default.createElement(
        'div',
        null,
        !isComplete && _react2.default.createElement(
            'div',
            { className: 'update' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'updateTag.update', defaultMessage: 'Update' })
        )
    );
};

var RequirementCard = function RequirementCard(_ref5) {
    var url = _ref5.url,
        requirementSet = _ref5.requirementSet,
        isComplete = _ref5.isComplete;
    return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
            'td',
            { className: 'complete-tag' },
            _react2.default.createElement(CompleteTag, { isComplete: isComplete })
        ),
        _react2.default.createElement(
            'td',
            { className: 'name' },
            _react2.default.createElement(
                _reactRouter.Link,
                { to: url, 'aria-label': 'Due By Date' },
                _react2.default.createElement(RequirementName, {
                    requirementSet: requirementSet,
                    isComplete: isComplete })
            )
        ),
        _react2.default.createElement(
            'td',
            { className: 'due-by' },
            _react2.default.createElement(
                _reactRouter.Link,
                { to: url, 'aria-label': 'Due By Date' },
                _react2.default.createElement(DueByDate, {
                    requirementSet: requirementSet,
                    isComplete: isComplete
                })
            )
        ),
        _react2.default.createElement(
            'td',
            { className: 'update-tag' },
            _react2.default.createElement(
                _reactRouter.Link,
                { to: url, 'aria-label': 'Update Tag' },
                _react2.default.createElement(UpdateTag, { isComplete: isComplete })
            )
        )
    );
};

RequirementCard = (0, _pacomo.pacomoTransformer)(RequirementCard);

var ReqCounter = function ReqCounter(_ref6) {
    var totalReqSets = _ref6.totalReqSets,
        reqSetsComplete = _ref6.reqSetsComplete;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: 'header' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'requirementCards.counter.header',
                defaultMessage: 'Completed'
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'counter-container' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'requirementCards.counter',
                defaultMessage: '{completed}/{total}',
                values: {
                    completed: '' + reqSetsComplete, // Ensure '0' appears as a string
                    total: totalReqSets
                }
            })
        )
    );
};

var RequirementCards = function RequirementCards(props) {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(ReqCounter, {
            className: 'counter',
            totalReqSets: props.requirementSetsByCustomerId.totalReqSets,
            reqSetsComplete: props.requirementSetsByCustomerId.reqSetsComplete
        }),
        _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
                'tbody',
                null,

                // TODO: Make the url less hardcoded?
                props.requirementSetsByCustomerId.reqSets.map(function (reqSet, i) {
                    return _react2.default.createElement(RequirementCard, {
                        className: 'RequirementCard',
                        key: i,
                        url: '/' + props.passengerId + '/' + reqSet.code,
                        requirementSet: reqSet,
                        isComplete: reqSet.totalReqs === reqSet.reqsComplete });
                })
            )
        ),
        _react2.default.createElement(_components2.Legal, { className: 'legal' })
    );
};
RequirementCards = (0, _pacomo.pacomoTransformer)(RequirementCards);
ReqCounter = (0, _pacomo.pacomoTransformer)(ReqCounter);
exports.default = RequirementCards;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSetList/RequirementCards.js
// module id = 1335
// module chunks = 0